import { ActionType } from "../ChatAction";

export default function setSessionId(sessionId: string): ActionType {
    return {
        type: "session_id",
        detail: {
            sessionId,
            timestamp: new Date().getTime()
        }
    };
}